import {
    GET_APPROVED_FINANCIAL_AID,
    GET_APPROVED_FINANCIAL_AID_SUCCESS,
    GET_APPROVED_FINANCIAL_AID_FAIL,
 
  
    FINANCIAL_AID_DETAILS,
    FINANCIAL_AID_DETAILS_SUCCESS,
    FINANCIAL_AID_DETAILS_FAIL,
    GET_FA_APT_DETAILS,
    GET_FA_APT_DETAILS_SUCCESS,
    GET_FA_APT_DETAILS_FAIL,
    GET_ALL_DONATIONS,
    GET_ALL_DONATIONS_SUCCESS,
    GET_ALL_DONATIONS_FAIL,
    DONATION_TOTAL,
    DONATION_TOTAL_SUCCESS,
    DONATION_TOTAL_FAIL,
  
  } from "./actionTypes";
  
  export const getPendingFinancialAid = () => ({
    type: GET_PENDING_FINANCIAL_AID,
  });
  
  export const getPendingFinancialAidSuccess = FA => ({
    type: GET_PENDING_FINANCIAL_AID_SUCCESS,
    payload: FA,
  });
  
  export const getPendingFinancialAidFail = error => ({
    type: GET_PENDING_FINANCIAL_AID_FAIL,
    payload: error,
  });
  
  export const getApprovedFinancialAid = () => ({
    type: GET_APPROVED_FINANCIAL_AID,
  });
  
  export const getApprovedFinancialAidSuccess = FA => ({
    type: GET_APPROVED_FINANCIAL_AID_SUCCESS,
    payload: FA,
  });
  
  export const getApprovedFinancialAidFail = error => ({
    type: GET_APPROVED_FINANCIAL_AID_FAIL,
    payload: error,
  });
  
  export const acceptFinancialAid = id => ({
    type: ACCEPT_FINANCIAL_AID,
    payload: id,
  });
  
  export const acceptFinancialAidSuccess = FA => ({
    type: ACCEPT_FINANCIAL_AID_SUCCESS,
    payload: FA,
  });
  
  export const acceptFinancialAidFail = error => ({
    type: ACCEPT_FINANCIAL_AID_FAIL,
    payload: error,
  });
  
  export const rejectFinancialAid = (id,Response,history) => ({
    type: REJECT_FINANCIAL_AID,
    payload: {id,Response,history},
  });
  
  export const rejectFinancialAidSuccess = FA => ({
    type: REJECT_FINANCIAL_AID_SUCCESS,
    payload: FA,
  });
  
  export const rejectFinancialAidFail = error => ({
    type: REJECT_FINANCIAL_AID_FAIL,
    payload: error,
  });
  
  export const financialAidDetails = id => ({
    type: FINANCIAL_AID_DETAILS,
    payload: id,
  });
  
  export const financialAidDetailsSuccess = FA => ({
    type: FINANCIAL_AID_DETAILS_SUCCESS,
    payload: FA,
  });
  
  export const financialAidDetailsFail = error => ({
    type: FINANCIAL_AID_DETAILS_FAIL,
    payload: error,
  });
  
  export const getFAAptDetails = id => ({
    type: GET_FA_APT_DETAILS,
    payload: id,
  });
  
  export const getFAAptDetailsSuccess = FA_Apt => ({
    type: GET_FA_APT_DETAILS_SUCCESS,
    payload: FA_Apt,
  });
  
  export const getFAAptDetailsFail = error => ({
    type: GET_FA_APT_DETAILS_FAIL,
    payload: error,
  });
  
  
  export const getAllDonations = () => ({
    type: GET_ALL_DONATIONS,
  });
  
  
  export const getAllDonationsSuccess = donations => ({
    type: GET_ALL_DONATIONS_SUCCESS,
    payload: donations,
  });
  
  export const getAllDonationsFail = error => ({
    type: GET_ALL_DONATIONS_FAIL,
    payload: error,
  });
  
  export const donationTotal = () => ({
    type: DONATION_TOTAL,
  });
  
  export const donationTotalSuccess = totaldonation => ({
    type: DONATION_TOTAL_SUCCESS,
    payload: totaldonation,
  });
  
  export const donationTotalFail = error => ({
    type: DONATION_TOTAL_FAIL,
    payload: error,
  });
  